import React from 'react';

import { Container, Grid } from '@mui/material';
import Typography from '@mui/material/Typography';

const ErrorFallback = () => (
    <Container>
        <Grid container spacing={3}>
            <Grid xs={12} sx={{ margin: '20px', color: 'error.main' }}>
                <Typography variant="h1">Something went wrong</Typography>
            </Grid>
            <Grid xs={12} sx={{ margin: '20px', color: 'error.main' }}>
                <Typography variant="body1">An unexpected error occurred.</Typography>
            </Grid>
        </Grid>
    </Container>
);

export default ErrorFallback;
